import { create } from 'zustand'
import contactService from '../services/contactService'

const useContactStore = create((set) => ({
    contacts: [],
    loading: false,
    error: null,

    fetchContacts: async () => {
        set({ loading: true, error: null })
        try {
            const { success, data, message } = await contactService.getContacts()
            if (success) {
                set({ contacts: data, loading: false })
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    fetchContact: async (contactId) => {
        set({ loading: true, error: null })
        try {
            const { success, data, message } = await contactService.getContact(contactId)
            if (success) {
                set((state) => ({ contact: data, loading: false }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    createContact: async (contactData) => {
        set({ loading: true, error: null })
        const { success, message } = await contactService.createContact(contactData)
        if (success) {
            set((state) => ({ contact: contactData, loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Create Contact Error:', message)
            return { success: false, message }
        }
    },

    updateContact: async (contactId, contactData) => {
        set({ loading: true, error: null })
        const { success, message } = await contactService.updateContact(contactId, contactData)
        if (success) {
            set((state) => ({ contact: contactData, loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Update Contact Error:', message)
            return { success: false, message }
        }
    },

    deleteContact: async (contactId) => {
        set({ loading: true, error: null })
        try {
            const { success, message } = await contactService.deleteContact(contactId)
            if (success) {
                set((state) => ({
                    contacts: state.contacts.filter((contact) => contact.id !== contactId),
                    loading: false,
                }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    clearState: () => {
        set({ loading: false, error: null })
    },
}))

export default useContactStore
